module.exports = __webpack_public_path__ + "static/media/blue-star.c1b71085.svg";